import { render, staticRenderFns } from "./sports.vue?vue&type=template&id=44877903&scoped=true&"
import script from "./sports.vue?vue&type=script&lang=js&"
export * from "./sports.vue?vue&type=script&lang=js&"
import style0 from "./sports.vue?vue&type=style&index=0&id=44877903&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44877903",
  null
  
)

export default component.exports